import { Box, Grid, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import SimpleModal from 'src/Component/SimpleModal'
import { useGetAITrainerExerciseDetailsByIdQuery } from 'src/api/aiTrainerApi'
import { AppDispatch } from 'src/store'
import { startPageLoader, stopPageLoader } from 'src/store/features/common/commonSlice'

type ViewExerciseDetailsModalProps = {
  id: number
  open: boolean
  onClose: () => void
}
const ViewExerciseDetailsModal = ({ id, open, onClose }: ViewExerciseDetailsModalProps) => {
  const dispatch = useDispatch<AppDispatch>()
  const { data, isFetching, refetch } = useGetAITrainerExerciseDetailsByIdQuery(id)

  useEffect(() => {
    if (isFetching) {
      dispatch(startPageLoader())
    } else {
      dispatch(stopPageLoader())
    }
  }, [isFetching])

  return (
    <Box>
      <SimpleModal open={!!(open && id)} onClose={onClose}>
        {!!data && (
          <Box>
            {!!data?.video && (
              <Box textAlign='center'>
                <video
                  src={data?.video}
                  style={{
                    height: '250px',
                    objectFit: 'cover',
                  }}
                  controls
                />
              </Box>
            )}

            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Exercise Name:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data?.name} </Typography>
              </Grid>
            </Grid>

            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Equipment Needed</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'>{data?.equipment_needed}</Typography>
              </Grid>
            </Grid>

            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Time</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'>{data?.time} mins</Typography>
              </Grid>
            </Grid>

            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Training Level</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data?.training_level} </Typography>
              </Grid>
            </Grid>

            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Instruction</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data?.instruction} </Typography>
              </Grid>
            </Grid>
          </Box>
        )}
      </SimpleModal>
    </Box>
  )
}

export default ViewExerciseDetailsModal
